import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import clsx from 'clsx';
import ImageComponent from '../ImageComponent';
import alertIcon from '../../assets/alert-line.svg';
import stylesInput from './input.module.css';
import { useTranslation } from 'react-i18next';
import stylesGlobal from '../../styles/referral/global.module.css';

type InputProps = {
    type: string;
    placeholder: string;
    value: string;
    stillclass?: string;
    label?: string;
    showLabelWithoutError?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    name: string;
    className: string;
    errorBox?: boolean;
    [key: string]: any;
    height?: number | string;
    divClassName?: string;
    beforeErrodicClassName?: string;
    inlineError?: string;
    redalertextraclass?: string;
    onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    autocomplete?: string;
}

type InputHandle = {
  focus: () => void;
};

const Input = forwardRef<InputHandle, InputProps>(({type, inlineError, placeholder, label,showLabelWithoutError=false, value, redalertextraclass=false, autocomplete='on', stillclass, onChange=()=>{}, name, divClassName, onKeyUp=()=>{}, keyDown=()=>{}, beforeErrodicClassName={}, height, className, errorBox, ...props}, ref) => {

  const inputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();


  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
    }
  }),[]);
  

  return (
    <>
    <div className={clsx('flex', !errorBox || !inlineError ? 'mb10' : '', 'alignItemCenter', 'justifyContentCenter', stillclass ,  beforeErrodicClassName, errorBox ? stylesInput.errorboxalert : divClassName , label && errorBox ? stylesInput.fullerrorbox : '', label && showLabelWithoutError && !errorBox && stylesInput.labelWithoutError, redalertextraclass && stylesInput.redalertextra)}>
        {label && errorBox && <span className={clsx(stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightMedium', 'moveupwrapperdiv')}>{label}</span>}
        {label && showLabelWithoutError && !errorBox && <span className={clsx(stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightMedium', 'labelWithoutError', 'moveupwithouterrorwrapperdiv')}>{label}</span>}
        { (type === 'phone' || type === 'tel') && <span className={clsx('numberextension', stylesGlobal.flex1, 'textAlignCenter')}>{t('numberextension')}</span>}
        <input type={type} placeholder={placeholder} autoComplete={autocomplete} value={value} onChange={onChange} name={name}  style={{ height }}  className={clsx(className, errorBox ? stylesGlobal.flex5 : stylesGlobal.flex6)} ref={inputRef} {...props} onKeyUp={onKeyUp} onKeyDown={keyDown} />
        {errorBox && <span className={clsx(errorBox && 'errorBox', stylesGlobal.flex1)}><ImageComponent className={stylesInput.inputAlertIcon} src={alertIcon} alt="error" /></span> }
    </div>
    {inlineError && errorBox && <span className={clsx(stylesGlobal.inlineError,errorBox && 'errorBox', stylesGlobal.flex1, 'fontSizeXs', 'fontWeightMedium', 'mb10')}>{inlineError}</span> }
    </>
  )
})


export default Input;